import { render, staticRenderFns } from "./resolution.vue?vue&type=template&id=54d7c482&scoped=true"
import script from "./resolution.vue?vue&type=script&lang=js"
export * from "./resolution.vue?vue&type=script&lang=js"
import style0 from "./resolution.vue?vue&type=style&index=0&id=54d7c482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d7c482",
  null
  
)

export default component.exports